import * as React from "react";
import { AppProvider, SignInPage } from "@toolpad/core";
import { useTheme } from "@mui/material/styles";
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useNavigate } from "react-router-dom";
import api from "../../api";

const providers = [{ id: "credentials", name: "Email and password" }];
const BRANDING = {
  logo: (
    <img
      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRJmSc0brwlO9vb26hdbP6l-Afftny9Py_dQKXL5-eefD8GJlgRgIzPHtRCKMBDLHLJl18&usqp=CAU"
      alt="UV logo"
      style={{ height: 125 }}
    />
  ),
  title: "Ultraviolette CMS",
};

const signIn = async (provider, formData, onSignIn) => {
  const promise = new Promise((resolve) => {
    setTimeout(() => {
      const email = formData?.get("email");
      const password = formData?.get("password");
      const remember = formData?.get("remember") || formData?.get("rememberMe");
      const rememberMe = remember === "on" || remember === "true";
      api.post("/api/auth/login", {
        email,
        password,
        rememberMe: rememberMe,
      })
        .then(function (response) {
          const data = response.data;

          if (data.accessToken) {
            localStorage.setItem("accessToken", data.accessToken);
            localStorage.setItem("userEmail", data.user.email);
            if (data.user.isAdmin) {
              localStorage.setItem("isAdmin", "true");
            } else {
              localStorage.removeItem("isAdmin");
            }
            onSignIn();
            resolve();
          } else {
            resolve({
              type: "CredentialsSignin",
              error: "Login failed: No token received.",
            });
          }
        })
        .catch(function (error) {
          console.error("Login Error:", error);
          resolve({
            type: "CredentialsSignin",
            error: error.response?.data?.message || error.response?.data?.msg || "Invalid credentials.",
          });
        });
    }, 300);
  });
  return promise;
};

/*function SignUpLinkComponent() {
  const navigate = useNavigate();
  return (
    <Stack direction="row" justifyContent="center" sx={{ mt: 3, mb: 2 }}>
      <Link 
        variant="body2"
        onClick={() => navigate("/signup")}
        style={{ cursor: 'pointer' }}
        sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
      >
        Don't have an account? Sign up
      </Link>
    </Stack>
  );
}*/

function CustomSubmitButton() {
  return (
    <>
      <FormControlLabel
        className="custom-remember-me"
        control={<Checkbox name="rememberMe" color="primary" />}
        label="Remember me"
        sx={{ width: '100%' }} // Ensure it takes full width if needed
      />
      <Button
        type="submit"
        fullWidth
        variant="contained"
        size="large"
        sx={{
          mt: 3,
          mb: 2,
          textTransform: 'capitalize',
          filter: 'opacity(0.9)',
          transition: 'filter 0.2s ease-in',
          '&:hover': {
            filter: 'opacity(1)'
          }
        }}
      >
        Sign In
      </Button>
      <style>{`
        /* Hide the default broken checkbox */
        form .MuiFormControlLabel-root:not(.custom-remember-me) {
          display: none !important;
        }
      `}</style>
    </>
  );
}

export default function SignIn({ onSignIn }) {
  const theme = useTheme();

  return (
    <AppProvider theme={theme} branding={BRANDING}>
      <SignInPage
        signIn={(provider, formData) => signIn(provider, formData, onSignIn)}
        providers={providers}
        onError={(error) => console.error("Sign-in error:", error)}
        slots={{
          //rememberMe: RememberMe,
          submitButton: CustomSubmitButton,
        }}
      //showRememberMe={true}
      />
    </AppProvider>
  );
}